export const getBenefitCoverage = (data: any) => {
  const currentCoverage = data?.current_coverage
  const futureCoverages = data?.future__coverages
  const pastCoverages = data?.past_coverages

  if (currentCoverage) return currentCoverage
  else if (futureCoverages && futureCoverages?.length) return futureCoverages[0]
  else if (pastCoverages && pastCoverages?.length) return pastCoverages[0]
}
